// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_VMwkZ","secondaryColumnCell":"secondary-column-cell_VMwkZ","body":"body_e4IbM"};